exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.progress-bar-wrapper[data-v-591eb436] {\n    text-align: center;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n}\n.item-label[data-v-591eb436] {\n    font-size: 16px;\n    margin-bottom: 6px;\n}\n", ""]);

// exports
